import {
    GET_EVENTS,
    CLEAR_EVENTS,
    SET_EVENT_PAGE_EVENT_TYPE
} from "../actiontypes";

//! Composed URL For API
import ApiPath from "../utils/Apis/ApiPath";
import { MEETING_TYPES } from "../utils/Generic/meetingTypes";

//! EVENTS REDUCER ACTION CREATORS
// Gets Event List For Search
export const getEvents = formValues => async (dispatch, getState) => {
    const type = "json";

    if (formValues) {
        let eDateStart = formValues.eDateStart;
        let eDateEnd = formValues.eDateEnd;
        let eTitle = formValues.eTitle;

        if (!eDateStart) {
            eDateStart = "";
        }

        if (!eDateEnd) {
            eDateEnd = "";
        }

        if (!eTitle) {
            eTitle = "";
        }

        const unfiltered = getState().events;

        const eventsFiltered = unfiltered.filter(event => {
            return event.eventName === eTitle;
        });

        // Dispatch = Async
        dispatch({ type: GET_EVENTS, payload: eventsFiltered });
    } else {
        // Only Call Api If Events Have Never Been Loaded
        const { sessionId, companyId } = getState().user.user;

        const response = await fetch(
            `${ApiPath.urlApi}/api/events/getEvents?db=${ApiPath.db}&type=${type}&SessionId=${sessionId}&CompId=${companyId}`
        );

        const responseParsed = await response.json();

        // Dispatch = Async
        dispatch({ type: GET_EVENTS, payload: responseParsed });
    }
};

// Clears Events Array In State
export const clearEvents = () => {
    // Return = Sync
    return {
        type: CLEAR_EVENTS
    };
};

export const setEventPageEventType = eventType => {
    return {
        type: SET_EVENT_PAGE_EVENT_TYPE,
        payload: MEETING_TYPES[eventType]
    };
};
